export default __webpack_public_path__ + "static/media/logoYamaha.094191a6.svg";